import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// index.html carries default title/description/OG tags for crawlers that don't run JavaScript.
// Once the app runs, each page sets its own (components/SEO.js), so drop the defaults to avoid duplicates.
document.querySelectorAll("head [data-default-seo]").forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
